import React, { useState, useEffect } from "react";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate, useLocation } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import axiosInstance from "../../../../services/api/API";
import { showCustomAlert } from "../../../../customComponents/CustomSweetAlert";
import Swal from "sweetalert2";
import validations from "../../../../../helpers/validations";
import { buttonStyle, isFormValid } from "../../../../../helpers/common";
import Loader from "../../../../customComponents/CustomLoader";

const AddNewTerm = () => {
  const [formData, setFormData] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const authToken = localStorage.getItem("authToken");
  const [isLoading, setIsLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [userTypedd, setUserTypedd] = useState([]);

  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("businessPartnerId");

  const { rowData } = location.state || {};

  const TermInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-3",
            validation: validations.businessPartnerId({ required: true }),
          },
        ]
      : []),
    {
      name: "term_name",
      label: "Termset Name",
      type: "text",
      required: true,
      gridClass: "col-lg-3",
      validation: validations.termName({ required: true }),
      //  validation: {
      //         required: true,
      //         pattern: /^[A-Za-z0-9 ]*$/,
      //        message: "Only alphabets and digits are allowed",
      //         maxLength: 40,
      //       },
      // validation: {
      //   required: true,

      //   minLength: 5,
      //   maxLength: 40,

      //   // Enforces no spaces + length 5–100
      //   pattern: /^[A-Za-z0-9\-\/!&]{5,40}$/,

      //   message:
      //     "Termset Name must be 5–40 characters long, without spaces, and may contain only letters, numbers, and the special characters - / ! &",
      // },
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      gridClass: "col-lg-4",
    },
    // {
    //   name: "status",
    //   label: "Status",
    //   type: "dropdown",
    //   required: true,
    //   options: [
    //     { label: "Active", value: "Active" },
    //     { label: "Inactive", value: "Inactive" },
    //   ],
    //   gridClass: "col-lg-3",
    //   validation: { required: true },
    // },

    {
      name: "term_desc",
      label: "Description",
      type: "richeditor",
      gridClass: "col-lg-20",
      required: true,
      validation: { required: true },
    },
  ];

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };
  const isRichTextEmpty = (value) => {
    if (!value) return true;

    // Remove HTML tags
    const text = value
      .replace(/<(.|\n)*?>/g, "") // remove HTML tags
      .replace(/&nbsp;/g, " ") // replace &nbsp;
      .trim();

    return text.length === 0;
  };

  const handleFormSubmit = async (formData) => {
    // const errors = {};
    // let isValid = true;

    // Form validation
    // TermInputs.forEach((field) => {
    //   if (field.validation && field.validation.required) {
    //     if (!formData[field.name]) {
    //       errors[field.name] = "This field is required";
    //       isValid = false;
    //     }
    //   }
    // });
    const errors = {};
    let isValid = true;

    TermInputs.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required) {
        if (field.type === "richeditor") {
          if (isRichTextEmpty(value)) {
            errors[field.name] = "This field is required";
            isValid = false;
            return;
          }
        } else if (!value) {
          errors[field.name] = "This field is required";
          isValid = false;
          return;
        }
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    try {
      setIsLoading(true);
      const payload = {
        term_name: formData.term_name,
        term_desc: formData.term_desc,
        status: formData?.status === true ? 1 : 0,
      };

      // if (userType === "superadmin") {
      //   payload.business_partner_id = formData.business_partner_id;
      // } else {
      //   payload.business_partner_id = businessPartnerId;
      // }

      // Display confirmation dialog before proceeding
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to add this record?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      // If the user cancels, exit early
      if (!confirmation.isConfirmed) {
        setIsLoading(false); // Reset loading state
        return;
      }

      // Perform API call to submit form data
      const response = await axiosInstance.post("/termset/create", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log("API Response:", response.data);

      // Success message after API call
      Swal.fire({
        title: "Success!",
        text: "Termset added successfully.",
        icon: "success",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        // Navigate after success
        navigate(ROUTES_NAVIGATION.TERMLIST);
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      const errorMessage = error?.response?.data?.message;
      // Error alert in case of failure
      Swal.fire({
        title: "Error!",
        text: errorMessage
          ? errorMessage
          : "Failed to add the termset. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false); // Always reset loading state at the end
    }
  };

  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2">
            <img onClick={() => navigate(-1)} src={backicon} alt="back" />
            <span className="backbtntitle">Add New Term</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Term Details
            </span>
            <DynamicForm
              formConfig={TermInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
          <div className="btncontainer mt-3">
            <button
              className="submit-btn"
              disabled={
                !isFormValid(TermInputs, formData, validationErrors) ||
                isLoading
              }
              style={buttonStyle(
                TermInputs,
                formData,
                validationErrors,
                isLoading,
              )}
              onClick={() => {
                if (!isFormSubmitted) {
                  handleFormSubmit(formData);
                }
              }}
            >
              {isLoading ? "Processing..." : "Submit"}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AddNewTerm;
